import React from "react";
import { connectRefinementList } from "react-instantsearch/connectors";
import AttributeRefinementContainer from "../AttributeRefinementContainer";
import AttributeRefinementBox from "../AttributeRefinementBox";
import AttributeRefinementRow from "../AttributeRefinementRow";

class ConnectedAttributeRefinementContainer extends React.Component {
  handleRefinement = value => {
    const { canRefine, refine } = this.props;
    if (canRefine) refine(value);
  };

  render() {
    const { items } = this.props;
    return (
      <AttributeRefinementContainer>
        {items.map((item, key) => {
          const { label, count, isRefined } = item;
          return (
            <AttributeRefinementBox
              isLastElement={key === items.length - 1}
              key={key}
              onClick={() => this.handleRefinement(item.value)}
            >
              <AttributeRefinementRow
                attribute={label}
                count={count}
                isRefined={isRefined}
              />
            </AttributeRefinementBox>
          );
        })}
      </AttributeRefinementContainer>
    );
  }
}

export default connectRefinementList(ConnectedAttributeRefinementContainer);



// WEBPACK FOOTER //
// ./src/ConnectedAttributeRefinementContainer/ConnectedAttributeRefinementContainer.js